module.exports = __webpack_public_path__ + "img/login_logo.3320bf00.png";